export default __webpack_public_path__ + "static/media/ic-transport-only-menu.a4e6a18f.svg";